module.exports = __webpack_public_path__ + "img/magnesium-degraded.83316cd9.png";